// extracted by mini-css-extract-plugin
export var chip = "_dt-0";
export var filterDropdown = "_dt-5";
export var filterItem = "_dt-6";
export var icon = "_dt-1";
export var removeButton = "_dt-3";
export var removeIcon = "_dt-4";
export var separator = "_dt-2";